import { render, staticRenderFns } from "./NavbarProfile.vue?vue&type=template&id=2277aec6&"
import script from "./NavbarProfile.vue?vue&type=script&lang=js&"
export * from "./NavbarProfile.vue?vue&type=script&lang=js&"
import style0 from "./NavbarProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports